<div *ngIf="isOpen" class="fixed inset-0 flex items-center justify-center p-4" style="z-index: 99999;">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black/60" (click)="close()"></div>

  <!-- Dialog — fixed height, centered -->
  <div class="relative bg-white rounded-lg shadow-2xl w-full max-w-[850px] flex flex-col md:flex-row overflow-hidden" style="z-index: 100000; font-family: sans-serif; height: 65vh; min-height: 400px; max-height: 600px;">

    <!-- Close button (inside dialog, not overlapping) -->
    <button (click)="close()"
      class="absolute top-3 right-3 w-8 h-8 bg-[#f44336] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors z-10">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>

    <!-- Loading -->
    <div *ngIf="isLoading" class="flex-1 flex items-center justify-center">
      <div class="w-8 h-8 border-2 border-[#600b0b] border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- LEFT: Product Details (has internal scroll) -->
    <div *ngIf="!isLoading" class="flex-1 flex flex-col min-w-0 border-r border-gray-200">

      <!-- Heading (fixed) -->
      <div class="py-3 shrink-0 border-b border-gray-100">
        <h2 class="text-sm font-bold text-gray-900 text-center uppercase underline underline-offset-4 decoration-gray-300 tracking-wider">PRODUCT DETAILS</h2>
      </div>

      <!-- Frame Tabs with arrows (fixed) -->
      <div class="flex items-center border-b border-gray-200 shrink-0 px-1">
        <button (click)="scrollTabs(-1)" class="shrink-0 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div class="flex-1 overflow-x-auto no-scrollbar" #tabScroll>
          <div class="flex">
            <button *ngFor="let frame of frameDetail; let i = index" (click)="activeTab = i"
              [class]="'whitespace-nowrap px-5 py-2.5 text-[13px] font-medium transition-colors border-b-2 -mb-px shrink-0 ' + (activeTab === i ? 'text-gray-900 border-[#600b0b]' : 'text-gray-400 border-transparent hover:text-gray-600')">
              Frame {{ i + 1 }}
            </button>
          </div>
        </div>
        <button (click)="scrollTabs(1)" class="shrink-0 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>

      <!-- Frame table (THIS scrolls) -->
      <div class="flex-1 overflow-y-auto px-5 py-2">
        <div *ngIf="frameDetail[activeTab] as frame">
          <table class="w-full">
            <tbody>
              <tr class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Product</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ product?.name || 'Print & Frame' }}</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Sub-Product</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ collageLayout?.collage_type?.name || 'Multiframe Collage' }} ({{ productType?.name || 'Photo Frame' }})</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Image ID</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ getImageId(frame) }}</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Print Surface</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">Matte 175 GSM</td>
              </tr>
              <tr class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Print Size (in inches)</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ getPrintSize(frame) }}</td>
              </tr>
              <ng-container *ngIf="isFrame() && (frame.mount_id_1 > 0 || getMountName(frame, 1))">
                <tr class="border-b border-gray-100">
                  <td class="py-2 text-[13px] text-gray-500">Top Mount Color</td>
                  <td class="py-2 text-[13px] text-gray-900 text-right">{{ getMountName(frame, 1) || 'N/A' }}</td>
                </tr>
                <tr *ngIf="getMountSize(frame, 1) > 0" class="border-b border-gray-100">
                  <td class="py-2 text-[13px] text-gray-500">Top Mount Size</td>
                  <td class="py-2 text-[13px] text-gray-900 text-right">{{ getMountSize(frame, 1) }}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="isFrame() && frame.mount_id_2 > 0">
                <tr class="border-b border-gray-100">
                  <td class="py-2 text-[13px] text-gray-500">Second Mount Color</td>
                  <td class="py-2 text-[13px] text-gray-900 text-right">{{ getMountName(frame, 2) || 'N/A' }}</td>
                </tr>
              </ng-container>
              <tr *ngIf="isFrame()" class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Frame Name</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ frame.frame_name || 'N/A' }}</td>
              </tr>
              <tr *ngIf="isFrame()" class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Frame Size</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ getFrameSize(frame) }}</td>
              </tr>
              <tr *ngIf="isFrame()" class="border-b border-gray-100">
                <td class="py-2 text-[13px] text-gray-500">Glass Type</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">Regular Glass</td>
              </tr>
              <tr>
                <td class="py-2 text-[13px] text-gray-500">Finished Size</td>
                <td class="py-2 text-[13px] text-gray-900 text-right">{{ getFinishedSize(frame) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- RIGHT: Pricing Details (NO scroll, always visible) -->
    <div *ngIf="!isLoading" class="w-full md:w-[340px] shrink-0 p-5 md:p-6 bg-[#fafafa]">
      <h2 class="text-sm font-bold text-gray-900 text-center mb-5 uppercase underline underline-offset-4 decoration-gray-300 tracking-wider">PRICING DETAILS</h2>

      <div *ngIf="pricingDetails">
        <table class="w-full">
          <tbody>
            <tr>
              <td class="py-2.5 text-[13px] text-red-600 font-medium">Product Price</td>
              <td class="py-2.5 text-[13px] text-red-600 text-right font-bold">₹{{ pricingDetails.total | number:'1.2-2' }}</td>
            </tr>
            <tr *ngIf="pricingDetails.discount_with_tax > 0">
              <td class="py-2.5 text-[13px] text-gray-700">Discount <span *ngIf="pricingDetails.discount_rate">({{ pricingDetails.discount_rate }}%)</span></td>
              <td class="py-2.5 text-[13px] text-gray-900 text-right">-₹{{ pricingDetails.discount_with_tax | number:'1.2-2' }}</td>
            </tr>
            <tr>
              <td class="py-2.5 text-[13px] text-gray-700">Tax ({{ pricingDetails.tax_rate || 18 }}%)</td>
              <td class="py-2.5 text-[13px] text-gray-900 text-right">₹{{ pricingDetails.total_tax | number:'1.2-2' }}</td>
            </tr>
            <tr class="border-t border-gray-300">
              <td class="py-3 text-[13px] text-red-600 font-bold">Estimated Total</td>
              <td class="py-3 text-[13px] text-red-600 text-right font-bold">₹{{ pricingDetails.amount_payable | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
        <p class="text-[10px] text-gray-500 text-right mt-2">(excluding shipping fee)</p>
      </div>
    </div>

  </div>
</div>
